import CapsuleCard from "~/components/CapsuleCard/CapsuleCard.jsx";
import "./CapsuleGrid.css";

const CapsuleGrid = ({ data, category, selectedCapsules, handleQuantityChange, totalItems }) => {
  const productVariants = data?.DynamicBox?.selectableProductVariants || [];

  return (
    <div className="capsule-grid">
      {productVariants
        .filter((product) => category === "All" || product.productTitle.includes(category))
        .map((product) => {
          const variant = product.productVariants?.[0];

          if (!variant) return null;

          const variantWithImage = {
            ...variant,
            imageSrc: product.productImageSrc,
          };

          const selectedCapsule = selectedCapsules.find(
            (item) => item.platformId === variantWithImage.platformId
          );
          const quantity = selectedCapsule ? selectedCapsule.quantity : 0;

          return (
            <CapsuleCard
              key={product.productPlatformId}
              data={data}
              product={product}
              variant={variantWithImage}
              handleQuantityChange={handleQuantityChange}
              quantity={quantity}
              totalItems={totalItems}
            />
          );
        })}
    </div>
  );
};

export default CapsuleGrid;
